import {
	GENERATE_INTERVISTA_CITTADINO_FAIL,
	GENERATE_INTERVISTA_CITTADINO_START, GENERATE_INTERVISTA_CITTADINO_SUCCESS,
	GENERATE_INTERVISTA_FAIL,
	GENERATE_INTERVISTA_INCOMPLETA_FAIL,
	GENERATE_INTERVISTA_INCOMPLETA_START,
	GENERATE_INTERVISTA_INCOMPLETA_SUCCESS,
	GENERATE_INTERVISTA_START,
	GENERATE_INTERVISTA_SUCCESS, GET_INCOMPLETA_FAIL,
	GET_INCOMPLETA_START,
	GET_INCOMPLETA_SUCCESS,
	GET_INTERVISTA_FAIL,
	GET_INTERVISTA_START,
	GET_INTERVISTA_SUCCESS,
	
	SET_INTERVISTA, UPDATE_INTERVISTA_FAIL, UPDATE_INTERVISTA_START, UPDATE_INTERVISTA_SUCCESS,
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {
	GENERATE_INTERVISTA_CITTADINO_URL,
	GENERATE_INTERVISTA_INCOMPLETA_URL, GENERATE_INTERVISTA_OPR_URL,
	GENERATE_INTERVISTA_URL,
	GET_ALL_INTERVISTE_INCOMPLETE_URL,
	GET_ALL_INTERVISTE_URL,
	ON_CLICK_DETAILS_URL, SEGNA_GESTITI_URL,
	UPDATE_INTERVISTA_URL,
} from "./utils/ApiUrls";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {getConfig} from "./utils/ConfigUtils";
import {authLogout} from "./AuthServices";
import {setOpenSnackbar} from "./AppServices";

export function generateIntervista(intervista, dispatch) {
	axios
		.post(GENERATE_INTERVISTA_OPR_URL, intervista, getConfig())
		.then((response) => {
			dispatch({type: GENERATE_INTERVISTA_SUCCESS, payload: response.data})
		})
		.catch((error) => dispatch({type: GENERATE_INTERVISTA_FAIL, error: getErrorMessage(error)}))
}

export function segnaGestitiTamponiSoggetto(idSoggetto) {
	axios
		.get(SEGNA_GESTITI_URL + idSoggetto, getConfig())
		.then(() => console.log("Fatto!"))
}

export function generateIntervistaV2(intervista, dispatch, withToken = false) {
	dispatch({type: GENERATE_INTERVISTA_START});
	axios
		.post(GENERATE_INTERVISTA_URL, intervista, withToken ? getConfig() : {})
		.then((response) => {
			dispatch({
				type: GENERATE_INTERVISTA_SUCCESS,
				payload: response.data
			})
		})
		.catch((error) => dispatch({type: GENERATE_INTERVISTA_FAIL, error: getErrorMessage(error)}))
}

export function setIntervista(intervista, dispatch) {
	dispatch({type: SET_INTERVISTA, payload: intervista});
}

export function generateIntervistaIncompleta(intervistaIncompleta, dispatch, goTo = false) {
	dispatch({type: GENERATE_INTERVISTA_INCOMPLETA_START});
	axios
		.post(GENERATE_INTERVISTA_INCOMPLETA_URL, intervistaIncompleta, getConfig())
		.then((response) => {
			dispatch({type: GENERATE_INTERVISTA_INCOMPLETA_SUCCESS, payload: response.data})
			if (goTo) {
				axios
					.post(ON_CLICK_DETAILS_URL + "?id=" + response.data + "&tipoEntita=intervista_incompleta&azione=modify", {}, getConfig())
					.then((r2) => {
						if (r2.status === 226) {
							authLogout();
						} else {
							window.open(`http://localhost:3000/gestione/interviste/incompleta/${response.data}/focolaio/${intervistaIncompleta.idFocolaio}/soggetto/${intervistaIncompleta.idAnagraficaPazienteZero}/${intervistaIncompleta.tipoSoggetto?.replaceAll(".", "")}`, "_blank");
						}
					})
			}
		})
		.catch((error) => dispatch({type: GENERATE_INTERVISTA_INCOMPLETA_FAIL, error: getErrorMessage(error)}))
}

export function generateIncompletaMulti(contatti, dispatch, appDispatch) {
	contatti.forEach(contatto => {
		if (contatto.nome !== "" && contatto.cognome !== "") {
			generateIntervistaIncompleta(contatto, dispatch);
		}
	})
	setOpenSnackbar("success", "Contatti salvati come interviste incomplete", appDispatch);
}

export function resetAddIntervista(dispatch) {
	dispatch({type: GENERATE_INTERVISTA_START});
}

export function resetAddIntervistaIncompleta(dispatch) {
	dispatch({type: GENERATE_INTERVISTA_INCOMPLETA_START});
}

export function getIntervistaById(idIntervista, dispatch) {
	dispatch({type: GET_INTERVISTA_START});
	axios
		.post(GET_ALL_INTERVISTE_URL + "0/dataUltimaModifica/ASC", {id: idIntervista}, getConfig())
		.then((response) => dispatch({type: GET_INTERVISTA_SUCCESS, payload: response.data[0]}))
		.catch((error) => dispatch({type: GET_INTERVISTA_FAIL, error: getErrorMessage(error)}))
}

export function getIncompletaById(id, dispatch) {
	dispatch({type: GET_INCOMPLETA_START});
	axios
		.post(GET_ALL_INTERVISTE_INCOMPLETE_URL + "0/dataUltimaModifica/ASC", {id: id}, getConfig())
		.then((response) => dispatch({type: GET_INCOMPLETA_SUCCESS, payload: response.data[0]}))
		.catch((error) => dispatch({type: GET_INCOMPLETA_FAIL, error: getErrorMessage(error)}))
}

export function updateIntervista(intervista, dispatch) {
	dispatch({type: UPDATE_INTERVISTA_START})
	axios
		.post(UPDATE_INTERVISTA_URL + intervista.id, intervista, getConfig())
		.then(() => dispatch({type: UPDATE_INTERVISTA_SUCCESS}))
		.catch((error) => dispatch({type: UPDATE_INTERVISTA_FAIL, error: getErrorMessage(error)}))
}

export function compilaCittadinoIncompleta(intervista, idIntervista, token, dispatch) {
	dispatch({type: GENERATE_INTERVISTA_CITTADINO_START});
	axios
		.post(GENERATE_INTERVISTA_CITTADINO_URL + idIntervista + "/" + token, intervista)
		.then(() => dispatch({type: GENERATE_INTERVISTA_CITTADINO_SUCCESS}))
		.catch((error) => dispatch({type: GENERATE_INTERVISTA_CITTADINO_FAIL, error: getErrorMessage(error)}))
}
